import { QueueType } from 'types';

export enum ReviewTaskType {
  reviewContract = 'reviewContract',
  reviewIdentity = 'reviewIdentity',
  reviewTitle = 'reviewTitle',
  reviewUploadedDocument = 'reviewUploadedDocument',
  reviewInstall = 'reviewInstall',
  reviewPermissionToOperate = 'reviewPermissionToOperate',
  reviewSystemActivation = 'reviewSystemActivation',
  reviewVoidedCheck = 'voidedCheck',
}

export enum QueueItemDisplayStatus {
  ready = 'Ready',
  pending = 'Pending',
  completed = 'Completed',
  rejected = 'Rejected',
  voided = 'Voided',
}

export enum TaskQueueSortField {
  CREATED_DESC = 'createdAtDescending',
  CREATED_ASC = 'createdAtAscending',
}

export const NamesOfQueuesInsidePackages: Partial<Record<QueueType, string>> = {
  [QueueType.domesticContent]: 'Domestic Content',
  [QueueType.electricianSignOff]: 'Electrician Sign Off',
  [QueueType.permissionToOperate]: 'Permission To Operate',
};
